import * as stylex from "@stylexjs/stylex";
import { encode } from "uqr";
import "@/theme/tokens.stylex";
import { colors, radii } from "@/theme/tokens.stylex";
type QrCodeProps = {
  value?: string;
  label: string;
  size?: number;
};
const CODE_PX = 150;
const styles = {
  code: (size: number) => [{
    kzqmXN: size != null ? "x5lhr3w" : size,
    kZKoxP: size != null ? "x16ye13r" : size,
    $$css: true
  }, {
    "--x-width": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(size),
    "--x-height": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(size)
  }]
};
export function QrCode({
  value,
  label,
  size = CODE_PX
}: QrCodeProps) {
  const code = value === undefined ? undefined : encode(value, {
    ecc: "M",
    border: 1
  });
  return <span className="x2lah0s x78zum5 xc7ga6q xh540kj x1fv5t7x">
      <svg role="img" aria-label={label} viewBox={`0 0 ${code?.size ?? 1} ${code?.size ?? 1}`} shapeRendering="crispEdges" {...stylex.props(styles.code(size))}>
        {code && <path d={modulesPath(code.data)} className="xtldhx4" />}
      </svg>
    </span>;
}
function modulesPath(modules: readonly (readonly boolean[])[]): string {
  return modules.flatMap((row, y) => row.flatMap((dark, x) => dark ? [`M${x} ${y}h1v1h-1z`] : [])).join("");
}